var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": $t("276j896", "编辑邀请链接"),
      "mask-closable": false
    },
    on: {
      "on-visiable-change": _vm.reset
    },
    model: {
      value: _vm.visiable,
      callback: function ($$v) {
        _vm.visiable = $$v;
      },
      expression: "visiable"
    }
  }, [_c('Form', {
    ref: "formRef",
    staticClass: "max-w-[500px] w-[100%]",
    attrs: {
      "model": _vm.inviteForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": $t("df6s344", "有效期限"),
      "prop": "validityType"
    }
  }, [_c('Select', {
    directives: [{
      name: "width",
      rawName: "v-width",
      value: 300,
      expression: "300"
    }],
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": $t("x7skfb7", "请选择有效期限"),
      "transfer": ""
    },
    model: {
      value: _vm.inviteForm.validityType,
      callback: function ($$v) {
        _vm.$set(_vm.inviteForm, "validityType", $$v);
      },
      expression: "inviteForm.validityType"
    }
  }, _vm._l(_vm.validityTypeList, function (item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": $t("pgxs2", "部门")
    }
  }, [_c('div', {
    staticClass: "input ivu-input-wrapper"
  }, [_c('div', {
    staticClass: "pro_input_add flex gap-1",
    on: {
      "click": _vm.changeDepartment
    }
  }, _vm._l(_vm.orgList, function (item, index) {
    return _c('span', {
      key: index,
      staticClass: "bg-[#f8f8f8] rounded-sm p-[5px]"
    }, [_vm._v(_vm._s(item.name))]);
  }), 0)])]), _c('FormItem', {
    attrs: {
      "label": $t("4mu4s8h", "是否需要管理员审批新成员的加入申请"),
      "prop": "needApprove"
    }
  }, [_c('i-switch', {
    attrs: {
      "true-value": "T",
      "false-value": "F"
    },
    model: {
      value: _vm.inviteForm.needApprove,
      callback: function ($$v) {
        _vm.$set(_vm.inviteForm, "needApprove", $$v);
      },
      expression: "inviteForm.needApprove"
    }
  })], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v($t("kzjg2", "确定"))])], 1), _c('org-tree-modal', {
    ref: "orgTreeModalRef",
    on: {
      "on-update": _vm.getData
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };